module.exports = __webpack_public_path__ + "img/user_management.05156034.svg";